import { useTranslations } from "next-intl";
import PageSection from "@/common/page-section.common";
import AddIcon from "@mui/icons-material/Add";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
export const FAQ = () => {
  const t = useTranslations();
  return <PageSection heading={("Frequently Asked Questions")}>
      <div>
        <Accordion>
          <AccordionSummary expandIcon={<AddIcon />} aria-controls="panel1-content" id="panel1-header">
            <Typography variant="h6">{t("How long does the application process take")}</Typography>
          </AccordionSummary>
          <AccordionDetails>{t("The complete application process typically takes 44 days             approximately 67 weeks from submission to final decision             assuming no rejections or clarification requests")}</AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<AddIcon />} aria-controls="panel1-content" id="panel1-header">
            <Typography variant="h6">{t("What are the fees involved")}</Typography>
          </AccordionSummary>
          <AccordionDetails>{t("Fees must be paid via challan with payment proof to be uploaded             during the application submission process contact the Forest             Department for current fee amounts")}</AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary expandIcon={<AddIcon />} aria-controls="panel1-content" id="panel1-header">
            <Typography variant="h6">{t("Can I modify my application after submission")}</Typography>
          </AccordionSummary>
          <AccordionDetails>{t("You cannot directly edit your application after submission but you             can upload additional documents and provide clarifications when             requested by reviewing officers")}</AccordionDetails>
        </Accordion>
      </div>
    </PageSection>;
};
export default FAQ;